import React, { useState, useEffect, FormEvent } from "react";
import { useHistory } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Tooltip,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  InputGroup,
} from "react-bootstrap";

import api from "../../services/api";
import FotoUsuario from "../../components/FotoUsuario";
import MiniaturaFoto from "../../components/FotoUsuario/Miniatura";
import Template from "../../template";
import { toast } from "react-toastify";
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import * as XLSX from 'xlsx';

import * as S from "./styled";

import { useAuth } from "../../context/auth";

interface UsuarioAuth {
  user?: any;
  token?: String;
  nivel?: String;
  nome?: String;
  telefone?: String;
  cpf?: String | Number;
}

interface Usuario {
  name: string;
  password: string;
  email: string;
  phone: string;
  type: string;
  turma: string;
  telefone?: string | Number;
  cpf?: string | Number;
  /* chave da foto no Space; null para quem nunca enviou */
  foto?: string | null;
  id: number;
  ativado: number;
}

interface Turmas {
  type: string;
  name: string;
  description: string;
  id: number;
}

interface Pack {
  nome: string;
  qtd: string;
  sobra: string;
  id: number;
}

interface Redacao {
  aluno: string;
  nome: string;
  competencia1?: any;
  competencia2?: any;
  competencia3?: any;
  competencia4?: any;
  competencia5?: any;
}

function Usuarios() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const user: UsuarioAuth = useAuth();
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCPF] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("");
  const [userID, setUserId] = useState("");
  const [ativado, setAtivado] = useState(1);

  /*
    Dados do responsável — obrigatórios só quando type === "e" (estudante).
    O backend (POST /usuarios) recusa com 400 o cadastro de estudante sem eles, e é
    a partir daqui que ele cria o contrato e envia o link de assinatura por email.
  */
  const [respNome, setRespNome] = useState("");
  const [respCPF, setRespCPF] = useState("");
  const [respEmail, setRespEmail] = useState("");
  const [respPhone, setRespPhone] = useState("");
  const [errosResp, setErrosResp] = useState({ nome: "", cpf: "", email: "", telefone: "" });

  const ehEstudante = type === "e";

  const limparResponsavel = () => {
    setRespNome("");
    setRespCPF("");
    setRespEmail("");
    setRespPhone("");
    setErrosResp({ nome: "", cpf: "", email: "", telefone: "" });
  };

  // Estados para dropdown de busca de usuários
  const [buscaUsuario, setBuscaUsuario] = useState("");
  const [showDropdownUsuario, setShowDropdownUsuario] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");
  const [todosUsuarios, setTodosUsuarios] = useState<Usuario[]>([]);

  // Estados para filtros automáticos
  const [filtroTipoUsuario, setFiltroTipoUsuario] = useState("");
  const [filtroTurmaAtivo, setFiltroTurmaAtivo] = useState("");

  // Estado para armazenar todos os usuários filtrados (para paginação)
  const [todosUsuariosFiltrados, setTodosUsuariosFiltrados] = useState<Usuario[]>([]);

  const [reload, setReload] = useState("");

  const [turmaID, setTurmaID] = useState("");
  const [filtraTurma, setFiltraTurma] = useState("");
  const [turmas, setTurmas] = useState<Turmas[]>([]);

  const [pacotes, setPacotes] = useState<Pack[]>([]);
  const [redacoes, setRedacoes] = useState<Redacao[]>([]);

  const [media1, setMedia1] = useState(0);
  const [media2, setMedia2] = useState(0);
  const [media3, setMedia3] = useState(0);
  const [media4, setMedia4] = useState(0);
  const [media5, setMedia5] = useState(0);
  const [media6, setMedia6] = useState(0);

  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [usersPerPage, setUsersPerPage] = useState(10);

  /*
    Foto: campo opcional. `fotoArquivo` é o File escolhido nesta sessão (ainda não
    enviado) e `fotoAtual` é a chave já salva no banco, usada na edição.
    O upload vai numa chamada separada, depois de criar/editar o usuário.
  */
  const [fotoArquivo, setFotoArquivo] = useState<File | null>(null);
  const [fotoAtual, setFotoAtual] = useState<string | null>(null);

  const limparFoto = () => {
    setFotoArquivo(null);
    setFotoAtual(null);
  };

  /*
    Envia a foto do usuário. Não propaga erro: o cadastro/edição já foi salvo neste
    ponto e a foto é opcional — falhar aqui não pode desfazer o resto.
  */
  const enviarFoto = async (idUsuario: number | string, arquivo: File) => {
    try {
      const corpo = new FormData();
      corpo.append("foto", arquivo);

      await api.post(`/usuarios/${idUsuario}/foto`, corpo);
      return true;
    } catch (error) {
      console.error("Erro ao enviar a foto do usuário:", error);
      toast.warn("Usuário salvo, mas não foi possível enviar a foto. Tente novamente pela edição.");
      return false;
    }
  };

  /* Remove a foto já salva. Só existe na edição, onde há um usuário com id. */
  const removerFotoAtual = async (idUsuario: string | number) => {
    try {
      await api.delete(`/usuarios/${idUsuario}/foto`);
      setFotoAtual(null);
      setFotoArquivo(null);
      toast.success("Foto removida.");
      setReload(String(Date.now()));
    } catch (error) {
      console.error("Erro ao remover a foto:", error);
      toast.error("Não foi possível remover a foto.");
    }
  };

  /* Foto ampliada ao clicar na miniatura da listagem. */

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    // Limpar todos os campos do formulário
    setName("");
    setPassword("");
    setPasswordConfirm("");
    setEmail("");
    setCPF("");
    setPhone("");
    setType("");
    setUserId("");
    setAtivado(1);
    limparFoto();
    limparResponsavel();
  };
  const handleShow = () => setShow(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => {
    setShowEdit(false);
    // Limpar todos os campos do formulário
    setName("");
    setPassword("");
    setPasswordConfirm("");
    setEmail("");
    setCPF("");
    setPhone("");
    setType("");
    setUserId("");
    setAtivado(1);
    limparFoto();
  };

  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);

  const [showPacote, setShowPacote] = useState(false);
  const handleClosePacote = () => setShowPacote(false);

  const [showRedacao, setShowRedacao] = useState(false);
  const handleCloseRedacao = () => setShowRedacao(false);

  // Estados para importação de alunos via Excel
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState<File | null>(null);
  const [importTurmaId, setImportTurmaId] = useState("");
  const [importLoading, setImportLoading] = useState(false);
  const handleCloseImport = () => {
    setShowImportModal(false);
    setImportFile(null);
    setImportTurmaId("");
    setImportLoading(false);
  };
  const handleShowImport = () => setShowImportModal(true);

  // Estados para validação de senha
  const [passwordRequirements, setPasswordRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false
  });

  // Estados para mensagens de erro
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    phone: '',
    cpf: '',
    password: ''
  });

  // Funções de validação
  const validarEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validarTelefone = (telefone: string): boolean => {
    const telefoneRegex = /^\(?\d{2}\)?[\s-]?\d{4,5}[\s-]?\d{4}$/;
    return telefoneRegex.test(telefone.replace(/\D/g, '')) && telefone.replace(/\D/g, '').length >= 10;
  };

  const validarCPF = (cpf: string): boolean => {
    return cpfValidator.isValid(cpf);
  };

  const validarSenha = (senha: string) => {
    return {
      length: senha.length >= 6,
      uppercase: /[A-Z]/.test(senha),
      lowercase: /[a-z]/.test(senha),
      number: /\d/.test(senha),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(senha)
    };
  };

  // Funções para formatação
  const formatarTelefone = (valor: string): string => {
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length <= 2) return apenasNumeros;
    if (apenasNumeros.length <= 6) return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2)}`;
    if (apenasNumeros.length <= 10) return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 6)}-${apenasNumeros.slice(6)}`;
    return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7, 11)}`;
  };

  const formatarCPF = (valor: string): string => {
    const apenasNumeros = valor.replace(/\D/g, '');
    if (apenasNumeros.length <= 3) return apenasNumeros;
    if (apenasNumeros.length <= 6) return `${apenasNumeros.slice(0, 3)}.${apenasNumeros.slice(3)}`;
    if (apenasNumeros.length <= 9) return `${apenasNumeros.slice(0, 3)}.${apenasNumeros.slice(3, 6)}.${apenasNumeros.slice(6)}`;
    return `${apenasNumeros.slice(0, 3)}.${apenasNumeros.slice(3, 6)}.${apenasNumeros.slice(6, 9)}-${apenasNumeros.slice(9, 11)}`;
  };

  const removerFormatacaoTelefone = (telefone: string): string => {
    return telefone.replace(/\D/g, '');
  };

  const removerFormatacaoCPF = (cpf: string): string => {
    return cpf.replace(/\D/g, '');
  };

  // Handlers para os campos de input
  const handleInputChange = (field: string, value: string) => {
    const newErrors = { ...errors };

    switch (field) {
      case 'name':
        setName(value);
        newErrors.name = value.trim().length < 2 ? 'Nome deve ter pelo menos 2 caracteres' : '';
        break;
      case 'email':
        setEmail(value);
        newErrors.email = !validarEmail(value) && value.length > 0 ? 'Email inválido' : '';
        break;
      case 'phone':
        const telefoneFormatado = formatarTelefone(value);
        setPhone(telefoneFormatado);
        newErrors.phone = !validarTelefone(value) && value.length > 0 ? 'Telefone inválido' : '';
        break;
      case 'cpf':
        const cpfFormatado = formatarCPF(value);
        setCPF(cpfFormatado);
        newErrors.cpf = !validarCPF(value) && value.length > 0 ? 'CPF inválido' : '';
        break;
      case 'password':
        setPassword(value);
        const requirements = validarSenha(value);
        setPasswordRequirements(requirements);
        const allRequirementsMet = Object.values(requirements).every(req => req);
        newErrors.password = !allRequirementsMet && value.length > 0 ? 'Senha deve atender todos os requisitos abaixo' : '';
        break;
      default:
        break;
    }

    setErrors(newErrors);
  };

  /* Mesmos formatadores/validadores do aluno, aplicados aos campos do responsável. */
  const handleResponsavelChange = (campo: string, valor: string) => {
    const novos = { ...errosResp };

    switch (campo) {
      case "nome":
        setRespNome(valor);
        novos.nome = valor.trim().length < 2 ? "Nome deve ter pelo menos 2 caracteres" : "";
        break;
      case "cpf":
        setRespCPF(formatarCPF(valor));
        novos.cpf = !validarCPF(valor) && valor.length > 0 ? "CPF inválido" : "";
        break;
      case "email":
        setRespEmail(valor);
        novos.email = !validarEmail(valor) && valor.length > 0 ? "Email inválido" : "";
        break;
      case "telefone":
        setRespPhone(formatarTelefone(valor));
        novos.telefone = !validarTelefone(valor) && valor.length > 0 ? "Telefone inválido" : "";
        break;
      default:
        break;
    }

    setErrosResp(novos);
  };

  async function handleAddUser(e: FormEvent) {
    e.preventDefault();

    // Validação completa dos campos
    const newErrors = {
      name: name.trim().length < 2 ? 'Nome deve ter pelo menos 2 caracteres' : '',
      email: !validarEmail(email) ? 'Email inválido' : '',
      phone: !validarTelefone(phone) ? 'Telefone inválido' : '',
      cpf: !validarCPF(cpf) ? 'CPF inválido' : '',
      password: ''
    };

    /*
      Estudante não define senha aqui: ela é gerada e enviada por email quando o
      contrato é aprovado (a senha do banco é hash, não dá para recuperar depois).
    */
    const requirements = validarSenha(password);
    const allRequirementsMet = Object.values(requirements).every(req => req);
    if (type !== "e" && !allRequirementsMet) {
      newErrors.password = 'Senha deve atender todos os requisitos';
    }

    // Verificar se há erros
    const hasErrors = Object.values(newErrors).some(error => error !== '');
    if (hasErrors) {
      setErrors(newErrors);
      toast.error('Por favor, corrija os erros nos campos destacados');
      return;
    }

    // Verificar se todos os campos obrigatórios estão preenchidos
    if (!name.trim()) {
      toast.error('Por favor, preencha o nome do usuário.');
      setErrors(prev => ({ ...prev, name: 'Nome é obrigatório' }));
      return;
    }

    if (!email.trim()) {
      toast.error('Por favor, preencha o email do usuário.');
      setErrors(prev => ({ ...prev, email: 'Email é obrigatório' }));
      return;
    }

    if (!phone.trim()) {
      toast.error('Por favor, preencha o telefone do usuário.');
      setErrors(prev => ({ ...prev, phone: 'Telefone é obrigatório' }));
      return;
    }

    if (!cpf.trim()) {
      toast.error('Por favor, preencha o CPF do usuário.');
      setErrors(prev => ({ ...prev, cpf: 'CPF é obrigatório' }));
      return;
    }

    if (type !== "e" && !password.trim()) {
      toast.error('Por favor, preencha a senha do usuário.');
      setErrors(prev => ({ ...prev, password: 'Senha é obrigatória' }));
      return;
    }

    if (!type) {
      toast.error('Por favor, selecione o tipo de usuário.');
      return;
    }

    if (!turmaID) {
      toast.error('Por favor, selecione uma turma para o usuário.');
      return;
    }

    /*
      Estudante exige os dados do responsável: é com eles que o backend cria o contrato
      em relacao_responsavel_aluno e dispara o email com o link de assinatura.
    */
    if (type === "e") {
      const errosResponsavel = {
        nome: respNome.trim().length < 2 ? 'Nome deve ter pelo menos 2 caracteres' : '',
        cpf: !validarCPF(respCPF) ? 'CPF inválido' : '',
        email: !validarEmail(respEmail) ? 'Email inválido' : '',
        telefone: !validarTelefone(respPhone) ? 'Telefone inválido' : '',
      };

      setErrosResp(errosResponsavel);

      if (Object.values(errosResponsavel).some((erro) => erro !== '')) {
        toast.error('Preencha corretamente os dados do responsável.');
        return;
      }
    }

    const dataUser: Record<string, any> = {
      name: name.trim(),
      email: email.trim(),
      phone: removerFormatacaoTelefone(phone),
      type: type,
      cpf: removerFormatacaoCPF(cpf),
      turma_id: turmaID,
      ativado: ativado,
    };

    if (type !== "e") {
      dataUser.password = password;
    }

    if (type === "e") {
      dataUser.responsavel = {
        nome: respNome.trim(),
        cpf: removerFormatacaoCPF(respCPF),
        email: respEmail.trim(),
        telefone: removerFormatacaoTelefone(respPhone),
      };
    }

    try {
      let response = await api.post("/usuarios", dataUser);

      /*
        A foto vai depois porque só agora existe o id. Se falhar, o usuário já está
        cadastrado — o helper avisa e a foto pode ser anexada pela edição.
      */
      const idCriado = response?.data?.data?.usuario?.id;

      if (fotoArquivo && idCriado) {
        await enviarFoto(idCriado, fotoArquivo);
      }

      toast.success(
        type === "e"
          ? 'Aluno cadastrado! O link de assinatura foi enviado ao responsável.'
          : 'Usuário adicionado com sucesso!'
      );
      handleClose();

      // Limpar os campos
      setName("");
      setPassword("");
      setEmail("");
      setPhone("");
      setType("");
      setCPF("");
      setTurmaID("");
      setErrors({
        name: '',
        email: '',
        phone: '',
        cpf: '',
        password: ''
      });
      setPasswordRequirements({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false
      });

      setReload(response.data);
    } catch (error: any) {
      console.error('Erro ao adicionar usuário:', error);

      // Verificar se há uma resposta da API com detalhes do erro
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        /*
          Erro de validação do backend (zod) vem como { message: "Erro de validação...",
          errors: [{ path, message }] }. Sem este bloco a mensagem genérica venceria e o
          usuário não saberia qual campo recusou.
        */
        const errosValidacao = Array.isArray(errorData.errors) ? errorData.errors : null;
        const primeiroDetalhe = errosValidacao?.find((item: any) => item?.message)?.message;

        if (primeiroDetalhe) {
          toast.error(primeiroDetalhe);
          return;
        }

        // Verificar diferentes tipos de erro baseados na resposta da API
        if (errorData.message) {
          const message = errorData.message.toLowerCase();

          /*
            O backend responde "Email já cadastrado" / "CPF já cadastrado"
            (DadosUsuarioDuplicadosError). Sem 'já cadastrado' na lista, essa resposta
            caía no ramo genérico: o toast aparecia, mas o campo não era destacado.
          */
          const ehDuplicado =
            message.includes('já existe') ||
            message.includes('já cadastrado') ||
            message.includes('duplicado') ||
            message.includes('already exists');

          if (message.includes('email') && ehDuplicado) {
            toast.error('Este email já está cadastrado no sistema. Por favor, use outro email.');
            setErrors(prev => ({ ...prev, email: 'Email já cadastrado' }));
          } else if (message.includes('cpf') && ehDuplicado) {
            toast.error('Este CPF já está cadastrado no sistema. Por favor, verifique os dados.');
            setErrors(prev => ({ ...prev, cpf: 'CPF já cadastrado' }));
          } else if (message.includes('campo obrigatório') || message.includes('required')) {
            toast.error('Por favor, preencha todos os campos obrigatórios.');
          } else if (message.includes('email inválido') || message.includes('invalid email')) {
            toast.error('Por favor, insira um email válido.');
            setErrors(prev => ({ ...prev, email: 'Email inválido' }));
          } else if (message.includes('cpf inválido') || message.includes('invalid cpf')) {
            toast.error('Por favor, insira um CPF válido.');
            setErrors(prev => ({ ...prev, cpf: 'CPF inválido' }));
          } else {
            toast.error(errorData.message);
          }
        } else if (errorData.error) {
          toast.error(errorData.error);
        } else if (errorData.errors) {
          // Se houver múltiplos erros
          const firstError = Array.isArray(errorData.errors) ? errorData.errors[0] : errorData.errors;
          toast.error(firstError);
        } else {
          toast.error('Erro ao adicionar usuário. Verifique os dados e tente novamente.');
        }
      } else if (error.response && error.response.status) {
        // Tratar erros baseados no status HTTP
        switch (error.response.status) {
          case 400:
            toast.error('Dados inválidos. Por favor, verifique as informações preenchidas.');
            break;
          case 409:
            toast.error('Conflito: Email ou CPF já cadastrado no sistema.');
            break;
          case 422:
            toast.error('Dados inválidos. Verifique se todos os campos estão preenchidos corretamente.');
            break;
          case 500:
            toast.error('Erro interno do servidor. Tente novamente em alguns instantes.');
            break;
          default:
            toast.error('Erro ao adicionar usuário. Tente novamente.');
        }
      } else {
        // Erro de conexão ou outro erro não relacionado à API
        toast.error('Erro de conexão. Verifique sua internet e tente novamente.');
      }
    }
  }

  // Função para ler arquivo Excel
  function readExcelFile(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          resolve(jsonData);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsBinaryString(file);
    });
  }

  // Função para importar alunos via Excel
  async function handleImportAlunos(e: FormEvent) {
    e.preventDefault();

    // Validações
    if (!importTurmaId) {
      toast.error('Por favor, selecione uma turma.');
      return;
    }

    if (!importFile) {
      toast.error('Por favor, selecione um arquivo Excel.');
      return;
    }

    try {
      setImportLoading(true);

      // Ler arquivo Excel
      const excelData = await readExcelFile(importFile);

      if (!excelData || excelData.length === 0) {
        toast.error('O arquivo Excel está vazio ou não possui dados válidos.');
        setImportLoading(false);
        return;
      }

      // Validar colunas obrigatórias
      const firstRow = excelData[0];
      const requiredColumns = ['nome', 'email', 'telefone', 'cpf'];
      const missingColumns = requiredColumns.filter(col =>
        !Object.keys(firstRow).some(key => key.toLowerCase() === col)
      );

      if (missingColumns.length > 0) {
        toast.error(`Colunas obrigatórias faltando: ${missingColumns.join(', ')}`);
        setImportLoading(false);
        return;
      }

      // Preparar dados para envio
      const alunos = excelData.map((row: any) => {
        // Normalizar nomes das colunas (case-insensitive)
        const normalizedRow: any = {};
        Object.keys(row).forEach(key => {
          normalizedRow[key.toLowerCase()] = row[key];
        });

        return {
          nome: normalizedRow.nome || normalizedRow.name || '',
          email: normalizedRow.email || '',
          telefone: String(normalizedRow.telefone || normalizedRow.phone || '').replace(/\D/g, ''),
          cpf: String(normalizedRow.cpf || '').replace(/\D/g, ''),
          turma: parseInt(importTurmaId),
          senha: '123456'
        };
      });

      // Validar que todos os alunos têm os dados obrigatórios
      const invalidAlunos = alunos.filter(aluno =>
        !aluno.nome || !aluno.email || !aluno.telefone || !aluno.cpf
      );

      if (invalidAlunos.length > 0) {
        toast.error(`${invalidAlunos.length} aluno(s) com dados incompletos. Verifique o arquivo.`);
        setImportLoading(false);
        return;
      }

      // Enviar para API
      const response = await api.post('/importar-alunos', { alunos });

      toast.success(`${alunos.length} aluno(s) importado(s) com sucesso!`);

      // Fechar modal e limpar estados
      handleCloseImport();

      // Recarregar lista de usuários
      setReload(new Date().toString());

    } catch (error: any) {
      console.error('Erro ao importar alunos:', error);

      if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.message) {
          toast.error(errorData.message);
        } else if (errorData.detail) {
          toast.error(errorData.detail);
        } else {
          toast.error('Erro ao importar alunos. Verifique os dados e tente novamente.');
        }
      } else {
        toast.error('Erro ao importar alunos. Verifique sua conexão e tente novamente.');
      }
    } finally {
      setImportLoading(false);
    }
  }





  async function getPacote(e) {
    const dataUserId = {
      id: e.currentTarget.dataset.id,
    };

    let response = await api.post("/getPacote", dataUserId);

    setPacotes(response.data);
    setShowPacote(true);
  }

  async function getRedacoes(e) {
    const dataUserId = {
      id: e.currentTarget.dataset.id,
    };

    let response = await api.post("/getRedacoes", dataUserId);

    toast("Apenas redações já selecionadas pelo aluno serão exibidas.");

    let nota1 = 0;
    let nota2 = 0;
    let nota3 = 0;
    let nota4 = 0;
    let nota5 = 0;
    let nota6 = 0;
    let qtd = 0;

    response.data.redacoes.forEach((redacao) => {
      qtd = qtd + 1;
      if (
        redacao.competencia1 &&
        redacao.competencia2 &&
        redacao.competencia3 &&
        redacao.competencia4 &&
        redacao.competencia5
      ) {
        nota1 = parseInt(redacao.competencia1) + nota1;
        nota2 = parseInt(redacao.competencia2) + nota2;
        nota3 = parseInt(redacao.competencia3) + nota3;
        nota4 = parseInt(redacao.competencia4) + nota4;
        nota5 = parseInt(redacao.competencia5) + nota5;
        nota6 =
          parseInt(redacao.competencia1) +
          parseInt(redacao.competencia2) +
          parseInt(redacao.competencia3) +
          parseInt(redacao.competencia4) +
          parseInt(redacao.competencia5) +
          nota6;
      } else {
        nota1 = 0;
        nota2 = 0;
        nota3 = 0;
        nota4 = 0;
        nota5 = 0;
        nota6 = 0;
      }
    });

    setMedia1(Math.round(nota1 / qtd));
    setMedia2(Math.round(nota2 / qtd));
    setMedia3(Math.round(nota3 / qtd));
    setMedia4(Math.round(nota4 / qtd));
    setMedia5(Math.round(nota5 / qtd));
    setMedia6(Math.round(nota6 / qtd));

    setRedacoes(response.data.redacoes);
    setShowRedacao(true);
  }

  async function editUser(e) {
    // Buscar o data-id no botão (currentTarget) ao invés do elemento clicado (target)
    const userId = e.currentTarget.dataset.id;
    setUserId(userId);

    const dataUserId = {
      id: userId,
    };

    try {
      let response = await api.post("/pegarUser", dataUserId);

      setName(response.data[0].name);
      setEmail(response.data[0].email);
      setPhone(response.data[0].phone);
      setType(response.data[0].type);
      setTurmaID(response.data[0].turma_id);
      setAtivado(response.data[0].ativado);

      // foto já salva; a escolha nova começa vazia
      setFotoAtual(response.data[0].foto || null);
      setFotoArquivo(null);

      setShowEdit(true);
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
      toast.error('Erro ao carregar dados do usuário');
    }
  }

  async function handleEditUser(e: FormEvent) {
    e.preventDefault();

    let dataUser = {};

    if (password === "" && passwordConfirm === "") {
      dataUser = {
        name: name,
        email: email,
        phone: phone,
        type: type,
        id: userID,
        turma_id: turmaID,
        ativado: ativado,
      };
    } else if (
      password === passwordConfirm &&
      password.length >= 3 &&
      passwordConfirm.length >= 3
    ) {
      dataUser = {
        name: name,
        password: password,
        email: email,
        phone: phone,
        type: type,
        id: userID,
        turma_id: turmaID,
        ativado: ativado,
      };
    }

    let response = await api.put("/editUser", dataUser);

    // a foto vai à parte: /editUser recebe JSON e continua como está
    if (fotoArquivo) {
      await enviarFoto(userID, fotoArquivo);
    }

    handleCloseEdit();

    setName("");
    setPassword("");
    setPasswordConfirm("");
    setEmail("");
    setPhone("");
    setType("");

    setReload(response.data);
  }

  function deleteUser(e) {
    setUserId(e.currentTarget.dataset.id);
    setName(e.currentTarget.dataset.nome);
    setShowDelete(true);
  }

  async function handleDeleteUser(e: FormEvent) {
    e.preventDefault();

    let response = await api.delete(`/deleteUser/${userID}`);

    handleCloseDelete();

    setName("");

    setReload(response.data);
  }

  function getType(type) {
    if (type === "a") {
      return "Admin";
    } else if (type === "m") {
      return "Monitor";
    } else if (type === "s") {
      return "Suporte";
    } else if (type === "c") {
      return "Corretor";
    } else if (type === "t") {
      return "Teste";
    } else {
      return "Estudante";
    }
  }

  // Função para carregar usuários com paginação
  async function getUsuarios(page = 1) {
    try {
      setLoading(true);

      // Verificar se há filtros ativos
      const temFiltroUsuario = usuarioSelecionado;
      const temFiltroTurma = filtroTurmaAtivo;
      const temFiltroTipo = filtroTipoUsuario;

      if (temFiltroUsuario) {
        // Se há um usuário selecionado, fazer busca específica
        const dataBusca = {
          busca: usuarioSelecionado,
          page: page,
          limit: usersPerPage,
        };

        let response = await api.post("/buscaUser", dataBusca);

        if (response.data.users) {
          setUsuarios(response.data.users);
          setTotalPages(Math.ceil(response.data.total / usersPerPage));
          setTotalUsers(response.data.total);
        } else {
          // Fallback para API antiga
          setUsuarios(response.data);
          setTotalPages(1);
          setTotalUsers(response.data.length);
        }
      } else if (temFiltroTurma) {
        // Filtrar por turma
        if (page === 1) {
          // Primeira página - buscar todos os dados
          const dataFiltro = {
            id_turma: filtroTurmaAtivo,
          };

          let response = await api.post("/filtrar-alunos", dataFiltro);
          setTodosUsuariosFiltrados(response.data);

          // Implementar paginação no frontend
          const startIndex = (page - 1) * usersPerPage;
          const endIndex = startIndex + usersPerPage;
          const paginatedUsers = response.data.slice(startIndex, endIndex);

          setUsuarios(paginatedUsers);
          setTotalPages(Math.ceil(response.data.length / usersPerPage));
          setTotalUsers(response.data.length);
        } else {
          // Páginas subsequentes - usar dados já carregados
          const startIndex = (page - 1) * usersPerPage;
          const endIndex = startIndex + usersPerPage;
          const paginatedUsers = todosUsuariosFiltrados.slice(startIndex, endIndex);

          setUsuarios(paginatedUsers);
        }
      } else if (temFiltroTipo) {
        // Filtrar por tipo de usuário
        if (page === 1) {
          // Primeira página - buscar todos os dados
          const dataFilter = {
            filtro: filtroTipoUsuario,
          };

          let response = await api.post("/filterUsuarios", dataFilter);
          setTodosUsuariosFiltrados(response.data);

          // Implementar paginação no frontend
          const startIndex = (page - 1) * usersPerPage;
          const endIndex = startIndex + usersPerPage;
          const paginatedUsers = response.data.slice(startIndex, endIndex);

          setUsuarios(paginatedUsers);
          setTotalPages(Math.ceil(response.data.length / usersPerPage));
          setTotalUsers(response.data.length);
        } else {
          // Páginas subsequentes - usar dados já carregados
          const startIndex = (page - 1) * usersPerPage;
          const endIndex = startIndex + usersPerPage;
          const paginatedUsers = todosUsuariosFiltrados.slice(startIndex, endIndex);

          setUsuarios(paginatedUsers);
        }
      } else {
        // Carregar todos os usuários normalmente
        let response = await api.get(`/usuarios?page=${page}&limit=${usersPerPage}`);

        if (response.data.users) {
          // API com paginação
          setUsuarios(response.data.users);
          setTotalPages(Math.ceil(response.data.total / usersPerPage));
          setTotalUsers(response.data.total);
        } else {
          // Fallback para API antiga - implementar paginação no frontend
          const allUsers = response.data;
          const startIndex = (page - 1) * usersPerPage;
          const endIndex = startIndex + usersPerPage;
          const paginatedUsers = allUsers.slice(startIndex, endIndex);

          setUsuarios(paginatedUsers);
          setTotalPages(Math.ceil(allUsers.length / usersPerPage));
          setTotalUsers(allUsers.length);
        }
      }
    } catch (err) {
      console.error("Erro ao carregar usuários:", err);
    } finally {
      setLoading(false);
    }
  }

  async function getTurmas() {
    try {
      let response = await api.get("/classes");
      setTurmas(response.data);
    } catch (err) {
      console.error("Erro ao carregar turmas:", err);
    }
  }

  // Função para carregar todos os usuários (para o dropdown)
  async function getTodosUsuarios() {
    try {
      let response = await api.get("/usuarios?all=true");
      if (response.data.users) {
        setTodosUsuarios(response.data.users);
      } else {
        setTodosUsuarios(response.data);
      }
    } catch (err) {
      console.error("Erro ao carregar todos os usuários:", err);
    }
  }

  // Filtrar usuários por busca (para dropdown)
  const usuariosFiltrados = buscaUsuario.length > 0
    ? todosUsuarios.filter(usuario =>
      usuario.name.toLowerCase().includes(buscaUsuario.toLowerCase()) ||
      (usuario.cpf && usuario.cpf.toString().includes(buscaUsuario))
    ).slice(0, 10) // Limitar a 10 resultados
    : [];

  // Função para selecionar usuário do dropdown
  const selecionarUsuario = (usuario: Usuario) => {
    setUsuarioSelecionado(usuario.name);
    setBuscaUsuario("");
    setShowDropdownUsuario(false);

    // Filtrar usuários baseado na seleção
    const usuariosFiltrados = [usuario];
    setUsuarios(usuariosFiltrados);
    setTotalUsers(1);
    setTotalPages(1);
    setCurrentPage(1);
  };

  // Função para limpar filtros
  const limparFiltros = () => {
    setBuscaUsuario("");
    setUsuarioSelecionado("");
    setShowDropdownUsuario(false);
    setFiltroTipoUsuario("");
    setFiltroTurmaAtivo("");
    setFiltraTurma("");
    setTodosUsuariosFiltrados([]);
    setCurrentPage(1);
    setReload(new Date().toString());
  };

  useEffect(() => {
    getTurmas();
    getTodosUsuarios();
    getUsuarios(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, currentPage, filtroTipoUsuario, filtroTurmaAtivo, usersPerPage]);

  return (
    <Template>
      <style>
        {`
          .dropdown-item-hover:hover {
            background-color: #f8f9fa !important;
          }
          .dropdown-item-hover .font-weight-bold {
            color: #212529 !important;
          }
        `}
      </style>
      <S.MainWrapper>
        <Container fluid>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                {/* Cabeçalho da página */}
                <Row>
                  <Col sm={12}>
                    <div className="shadow-sm p-4 mb-4 bg-white rounded">
                      <S.CabecalhoPagina>
                        <div className="identidade">
                          <i className="fas fa-users text-primary mr-3"></i>
                          <div>
                            <h3 className="mb-0 text-dark font-weight-bold">Gerenciamento de Usuários</h3>
                            <p className="mb-0 text-muted">Gerencie usuários, permissões e informações do sistema</p>
                          </div>
                        </div>
                        <div className="contador">
                          <div className="numero text-primary">
                            {totalUsers}
                          </div>
                          <small className="text-muted font-weight-bold">
                            {totalUsers === 1 ? 'usuário encontrado' : 'usuários encontrados'}
                          </small>
                          {totalUsers > 0 && (
                            <div className="mt-2">
                              <small className="text-info font-weight-bold">
                                Página {currentPage} de {totalPages} |
                                Mostrando {((currentPage - 1) * usersPerPage) + 1}-{Math.min(currentPage * usersPerPage, totalUsers)} de {totalUsers}
                              </small>
                            </div>
                          )}
                        </div>
                      </S.CabecalhoPagina>
                    </div>
                  </Col>
                </Row>

                {/* Botão de adicionar usuário */}
                <Row>
                  <Col sm={12}>
                    <div className="shadow-sm p-3 mb-4 bg-white rounded">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-dark font-weight-bold">Ações Rápidas</h5>
                        <div className="d-flex gap-2">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={handleShow}
                            className="d-flex align-items-center mr-2"
                          >
                            <i className="fas fa-plus mr-2"></i>
                            Adicionar Usuário
                          </Button>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleShowImport}
                            className="d-flex align-items-center"
                          >
                            <i className="fas fa-file-excel mr-2"></i>
                            Importar alunos por xlsx
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* scrollable: em tela baixa o corpo rola sozinho, sem estourar a viewport */}
                <S.ModalUsuario show={show} onHide={handleClose} centered scrollable>
                  <Modal.Header closeButton>
                    <S.ModalCabecalho>
                      <div className="icone">
                        <i className="fas fa-user-plus" />
                      </div>
                      <div>
                        <h5>Adicionar usuário</h5>
                        <p>Preencha os dados para criar o acesso</p>
                      </div>
                    </S.ModalCabecalho>
                  </Modal.Header>

                  <Modal.Body>
                    <Form>
                      <S.Secao>
                        <S.SecaoTitulo>
                          <i className="fas fa-id-badge" /> Dados pessoais
                        </S.SecaoTitulo>

                        <S.Grade>
                          <S.Inteiro>
                            <S.CampoForm $erro={!!errors.name}>
                              <label>Nome completo</label>
                              <Form.Control
                                placeholder="Nome do usuário"
                                value={name}
                                onChange={(e) => handleInputChange('name', e.target.value)}
                                isInvalid={!!errors.name}
                              />
                              {errors.name && <span className="erro">{errors.name}</span>}
                            </S.CampoForm>
                          </S.Inteiro>

                          <S.CampoForm $erro={!!errors.email}>
                            <label>E-mail</label>
                            <Form.Control
                              placeholder="email@exemplo.com"
                              value={email}
                              onChange={(e) => handleInputChange('email', e.target.value)}
                              isInvalid={!!errors.email}
                            />
                            {errors.email && <span className="erro">{errors.email}</span>}
                          </S.CampoForm>

                          <S.CampoForm $erro={!!errors.phone}>
                            <label>Telefone</label>
                            <Form.Control
                              placeholder="(00) 00000-0000"
                              value={phone}
                              onChange={(e) => handleInputChange('phone', e.target.value)}
                              isInvalid={!!errors.phone}
                            />
                            {errors.phone && <span className="erro">{errors.phone}</span>}
                          </S.CampoForm>

                          <S.CampoForm $erro={!!errors.cpf}>
                            <label>CPF</label>
                            <Form.Control
                              placeholder="000.000.000-00"
                              value={cpf}
                              onChange={(e) => handleInputChange('cpf', e.target.value)}
                              isInvalid={!!errors.cpf}
                            />
                            {errors.cpf && <span className="erro">{errors.cpf}</span>}
                          </S.CampoForm>

                          <S.CampoForm>
                            <label>Turma</label>
                            <Form.Control
                              onChange={(e) => setTurmaID(e.target.value)}
                              as="select"
                              custom
                            >
                              <option value="">Selecione a turma</option>
                              {turmas &&
                                turmas.map((turma, idx) => (
                                  <option key={turma.id || idx} value={turma.id}>{turma.name}</option>
                                ))}
                            </Form.Control>
                          </S.CampoForm>

                          <S.Inteiro>
                            <S.CampoForm>
                              <label>Foto (opcional)</label>
                              <FotoUsuario
                                fotoAtual={null}
                                arquivo={fotoArquivo}
                                onEscolher={setFotoArquivo}
                                nome={name}
                              />
                            </S.CampoForm>
                          </S.Inteiro>
                        </S.Grade>
                      </S.Secao>

                      <S.Secao>
                        <S.SecaoTitulo>
                          <i className="fas fa-key" /> Acesso
                        </S.SecaoTitulo>

                        <S.Grade>
                          <S.CampoForm>
                            <label>Nível de acesso</label>
                            <Form.Control
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                              as="select"
                              custom
                            >
                              <option value="">Selecione o nível</option>
                              <option value="a">Admin</option>
                              <option value="m">Monitor</option>
                              <option value="e">Estudante</option>
                              <option value="s">Suporte</option>
                              <option value="c">Corretor</option>
                            </Form.Control>
                          </S.CampoForm>

                          <S.CampoForm>
                            <label>Situação</label>
                            <Form.Control
                              onChange={(e) => setAtivado(parseInt(e.target.value))}
                              as="select"
                              custom
                              defaultValue={ativado}
                              disabled={ehEstudante}
                            >
                              <option value="1">Ativo</option>
                              <option value="0">Inativo</option>
                            </Form.Control>
                            {ehEstudante && (
                              <span className="erro" style={{ color: '#8698ab', fontWeight: 500 }}>
                                Aluno entra inativo e é liberado após a aprovação do contrato.
                              </span>
                            )}
                          </S.CampoForm>

                          <S.Inteiro>
                            {ehEstudante ? (
                              /*
                                Aluno não define senha aqui: ela é gerada e enviada por
                                email na aprovação do contrato. A senha fica no banco só
                                como hash, então não haveria como reenviar a do cadastro.
                              */
                              <S.AvisoSenha>
                                <i className="fas fa-circle-info" />
                                <span>
                                  <strong>A senha é gerada automaticamente.</strong> Quando
                                  o contrato for aprovado, o aluno recebe por e-mail o login
                                  e uma senha de acesso.
                                </span>
                              </S.AvisoSenha>
                            ) : (
                            <S.CampoForm $erro={!!errors.password}>
                              <label>Senha</label>
                              <Form.Control
                                placeholder="Senha do usuário"
                                type="password"
                                value={password}
                                onChange={(e) => handleInputChange('password', e.target.value)}
                                isInvalid={!!errors.password}
                              />
                              {errors.password && <span className="erro">{errors.password}</span>}

                              {password && (
                                <S.RequisitosSenha>
                                  {[
                                    { ok: passwordRequirements.length, texto: '6+ caracteres' },
                                    { ok: passwordRequirements.uppercase, texto: '1 maiúscula' },
                                    { ok: passwordRequirements.lowercase, texto: '1 minúscula' },
                                    { ok: passwordRequirements.number, texto: '1 número' },
                                    { ok: passwordRequirements.special, texto: '1 caractere especial' },
                                  ].map((req) => (
                                    <S.Requisito key={req.texto} $ok={req.ok}>
                                      <i className={req.ok ? 'fas fa-check' : 'fas fa-xmark'} />
                                      {req.texto}
                                    </S.Requisito>
                                  ))}
                                </S.RequisitosSenha>
                              )}
                            </S.CampoForm>
                            )}
                          </S.Inteiro>
                        </S.Grade>
                      </S.Secao>

                      {/*
                        Só para estudante: o backend exige `responsavel` em POST /usuarios
                        quando type === "e", e é a partir daí que nasce o contrato.
                      */}
                      {ehEstudante && (
                        <S.Secao>
                          <S.SecaoTitulo>
                            <i className="fas fa-user-shield" /> Dados do responsável
                          </S.SecaoTitulo>

                          <S.BlocoResponsavel>
                            <p className="aviso">
                              Obrigatórios para aluno. O responsável recebe por e-mail o
                              contrato preenchido e o link para enviá-lo assinado — o aluno
                              só é liberado depois da aprovação.
                            </p>

                            <S.Grade>
                              <S.CampoForm $erro={!!errosResp.nome}>
                                <label>Nome do responsável</label>
                                <Form.Control
                                  placeholder="Nome completo"
                                  value={respNome}
                                  onChange={(e) => handleResponsavelChange('nome', e.target.value)}
                                  isInvalid={!!errosResp.nome}
                                />
                                {errosResp.nome && <span className="erro">{errosResp.nome}</span>}
                              </S.CampoForm>

                              <S.CampoForm $erro={!!errosResp.cpf}>
                                <label>CPF do responsável</label>
                                <Form.Control
                                  placeholder="000.000.000-00"
                                  value={respCPF}
                                  onChange={(e) => handleResponsavelChange('cpf', e.target.value)}
                                  isInvalid={!!errosResp.cpf}
                                />
                                {errosResp.cpf && <span className="erro">{errosResp.cpf}</span>}
                              </S.CampoForm>

                              <S.CampoForm $erro={!!errosResp.email}>
                                <label>E-mail do responsável</label>
                                <Form.Control
                                  placeholder="email@exemplo.com"
                                  value={respEmail}
                                  onChange={(e) => handleResponsavelChange('email', e.target.value)}
                                  isInvalid={!!errosResp.email}
                                />
                                {errosResp.email && <span className="erro">{errosResp.email}</span>}
                              </S.CampoForm>

                              <S.CampoForm $erro={!!errosResp.telefone}>
                                <label>Telefone do responsável</label>
                                <Form.Control
                                  placeholder="(00) 00000-0000"
                                  value={respPhone}
                                  onChange={(e) => handleResponsavelChange('telefone', e.target.value)}
                                  isInvalid={!!errosResp.telefone}
                                />
                                {errosResp.telefone && <span className="erro">{errosResp.telefone}</span>}
                              </S.CampoForm>
                            </S.Grade>
                          </S.BlocoResponsavel>
                        </S.Secao>
                      )}
                    </Form>
                  </Modal.Body>

                  <Modal.Footer>
                    <S.ModalRodape>
                      <Button variant="light" onClick={handleClose}>
                        Cancelar
                      </Button>
                      <Button variant="primary" onClick={handleAddUser}>
                        <i className="fas fa-check mr-2" />
                        Adicionar usuário
                      </Button>
                    </S.ModalRodape>
                  </Modal.Footer>
                </S.ModalUsuario>

                {/* Modal de Importação de Alunos */}
                <Modal show={showImportModal} onHide={handleCloseImport}>
                  <Modal.Header closeButton>
                    <Modal.Title>Importar Alunos por Excel</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group>
                        <Form.Label className="font-weight-bold">
                          <i className="fas fa-users text-primary mr-2"></i>
                          Selecione a Turma
                        </Form.Label>
                        <Form.Control
                          as="select"
                          value={importTurmaId}
                          onChange={(e) => setImportTurmaId(e.target.value)}
                          disabled={importLoading}
                        >
                          <option value="">Selecione uma turma...</option>
                          {turmas && turmas.map((turma, idx) => (
                            <option key={turma.id || idx} value={turma.id}>
                              {turma.name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>

                      <hr />

                      <Form.Group>
                        <Form.Label className="font-weight-bold">
                          <i className="fas fa-file-excel text-success mr-2"></i>
                          Arquivo Excel
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={(e: any) => setImportFile(e.target.files?.[0] || null)}
                          disabled={importLoading}
                        />
                        <Form.Text className="text-muted">
                          O arquivo deve conter as colunas: <strong>nome</strong>, <strong>email</strong>, <strong>telefone</strong> e <strong>cpf</strong>
                        </Form.Text>
                        <div className="mt-3">
                          <a
                            href={require('../../assets/arquivos_exemplos/Arquivo_exemplo.xlsx')}
                            download="Arquivo_exemplo.xlsx"
                            className="btn btn-outline-success btn-sm btn-block"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: 'bold'
                            }}
                          >
                            <i className="fas fa-download mr-2"></i>
                            Baixar Arquivo de Exemplo (.xlsx)
                          </a>
                        </div>
                      </Form.Group>

                      <hr />

                      <div className="alert alert-info">
                        <i className="fas fa-info-circle mr-2"></i>
                        <strong>Informações importantes:</strong>
                        <ul className="mb-0 mt-2">
                          <li>Todos os alunos receberão a senha padrão: <strong>123456</strong>, que poderá ser alterada posteriormente pelo aluno.</li>
                          <li>Os alunos serão vinculados à turma selecionada</li>
                          <li>Certifique-se de que o arquivo Excel está no formato correto</li>
                        </ul>
                      </div>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={handleCloseImport}
                      disabled={importLoading}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleImportAlunos}
                      disabled={importLoading}
                    >
                      {importLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Importando...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-upload mr-2"></i>
                          Importar
                        </>
                      )}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </S.MainContent>

              {/* Seção de Filtros Melhorada */}
              <Row className="mb-4">
                <Col sm={12}>
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-light border-0">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5 className="mb-0 text-dark font-weight-bold">
                          <i className="fas fa-filter text-primary mr-2"></i>
                          Filtros de Busca
                        </h5>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={limparFiltros}
                        >
                          <i className="fas fa-times mr-1"></i>
                          Limpar Filtros
                        </button>
                      </div>
                    </div>
                    <div className="card-body" style={{ overflow: 'visible' }}>
                      <Row>
                        {/* Controle de Itens por Página */}
                        <Col xs={12} md={3} className="mb-3">
                          <Form.Group>
                            <Form.Label className="font-weight-bold text-dark">
                              <i className="fas fa-list text-primary mr-1"></i>
                              Itens por Página
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Prepend>
                                <InputGroup.Text>
                                  <i className="fas fa-list"></i>
                                </InputGroup.Text>
                              </InputGroup.Prepend>
                              <Form.Control
                                as="select"
                                value={usersPerPage}
                                onChange={(e) => {
                                  setUsersPerPage(parseInt(e.target.value));
                                  setTodosUsuariosFiltrados([]);
                                  setCurrentPage(1);
                                }}
                                className="form-control-lg"
                              >
                                <option value={5}>5 por página</option>
                                <option value={10}>10 por página</option>
                                <option value={15}>15 por página</option>
                                <option value={20}>20 por página</option>
                                <option value={25}>25 por página</option>
                                <option value={50}>50 por página</option>
                              </Form.Control>
                            </InputGroup>
                          </Form.Group>
                        </Col>

                        {/* Busca por Nome/CPF com Dropdown */}
                        <Col xs={12} md={9} className="mb-3">
                          <Form.Group className="dropdown-container">
                            <Form.Label className="font-weight-bold text-dark">
                              <i className="fas fa-user text-primary mr-1"></i>
                              Buscar Usuário
                            </Form.Label>
                            <div style={{ position: 'relative' }}>
                              <InputGroup>
                                <InputGroup.Prepend>
                                  <InputGroup.Text>
                                    <i className="fas fa-search"></i>
                                  </InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control
                                  type="text"
                                  placeholder="Digite o nome do usuário..."
                                  value={buscaUsuario}
                                  onChange={(e) => {
                                    setBuscaUsuario(e.target.value);
                                    setShowDropdownUsuario(true);
                                  }}
                                  onFocus={() => {
                                    setShowDropdownUsuario(true);
                                  }}
                                  onBlur={() => setTimeout(() => setShowDropdownUsuario(false), 200)}
                                  className="form-control-lg"
                                />
                              </InputGroup>
                              {usuarioSelecionado && (
                                <div className="mt-1">
                                  <span className="badge badge-success">
                                    {usuarioSelecionado}
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-link text-white p-0 ml-2"
                                      style={{ fontSize: '0.7em' }}
                                      onClick={() => {
                                        setUsuarioSelecionado("");
                                        setReload(new Date().toString());
                                      }}
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              )}
                              {showDropdownUsuario && usuariosFiltrados.length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ced4da',
                                    borderTop: 'none',
                                    borderRadius: '0 0 0.375rem 0.375rem',
                                    maxHeight: '400px',
                                    overflowY: 'auto',
                                    zIndex: 9999,
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                                    marginTop: '-1px'
                                  }}
                                >
                                  {usuariosFiltrados.map((usuario, index) => (
                                    <div
                                      key={index}
                                      className="dropdown-item-hover"
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        borderBottom: index < usuariosFiltrados.length - 1 ? '1px solid #eee' : 'none',
                                        transition: 'background-color 0.2s ease'
                                      }}
                                      onClick={() => selecionarUsuario(usuario)}
                                    >
                                      <div className="d-flex align-items-center">
                                        <i className="fas fa-user text-muted mr-2"></i>
                                        <div>
                                          <div className="font-weight-bold text-dark">{usuario.name}</div>
                                          <small className="text-muted">
                                            {usuario.email} | {getType(usuario.type)}
                                            {usuario.cpf && ` | CPF: ${usuario.cpf}`}
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Segunda linha de filtros */}
                      <Row>
                        {/* Filtro por Turma - Automático */}
                        <Col xs={12} md={4} className="mb-3">
                          <Form.Group>
                            <Form.Label className="font-weight-bold text-dark">
                              <i className="fas fa-users text-primary mr-1"></i>
                              Filtrar por Turma
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Prepend>
                                <InputGroup.Text>
                                  <i className="fas fa-graduation-cap"></i>
                                </InputGroup.Text>
                              </InputGroup.Prepend>
                              <Form.Control
                                as="select"
                                value={filtroTurmaAtivo}
                                onChange={(e) => {
                                  setFiltroTurmaAtivo(e.target.value);
                                  setTodosUsuariosFiltrados([]);
                                  setCurrentPage(1);
                                }}
                                className="form-control-lg"
                              >
                                <option value="">Todas as Turmas</option>
                                {turmas &&
                                  turmas.map((turma, index) => (
                                    <option key={index} value={turma.id}>
                                      {turma.name}
                                    </option>
                                  ))}
                              </Form.Control>
                            </InputGroup>
                          </Form.Group>
                        </Col>

                        {/* Filtro por Tipo de Usuário - Automático */}
                        <Col xs={12} md={4} className="mb-3">
                          <Form.Group>
                            <Form.Label className="font-weight-bold text-dark">
                              <i className="fas fa-user-tag text-primary mr-1"></i>
                              Filtrar por Tipo de Usuário
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Prepend>
                                <InputGroup.Text>
                                  <i className="fas fa-shield-alt"></i>
                                </InputGroup.Text>
                              </InputGroup.Prepend>
                              <Form.Control
                                as="select"
                                value={filtroTipoUsuario}
                                onChange={(e) => {
                                  setFiltroTipoUsuario(e.target.value);
                                  setTodosUsuariosFiltrados([]);
                                  setCurrentPage(1);
                                }}
                                className="form-control-lg"
                              >
                                <option value="">Todos os Tipos</option>
                                <option value="a">
                                  Admin
                                </option>
                                <option value="m">
                                  Monitor
                                </option>
                                <option value="s">
                                  Suporte
                                </option>
                                <option value="c">
                                  Corretor
                                </option>
                                <option value="e">
                                  Estudante
                                </option>
                                <option value="nao">
                                  Inativos
                                </option>
                              </Form.Control>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Tabela de usuários */}
              <Row>
                <Col sm={12}>
                  <div className="shadow-sm bg-white rounded">
                    {loading && (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Carregando...</span>
                        </div>
                        <p className="mt-2 text-muted">Carregando usuários...</p>
                      </div>
                    )}

                    {!loading && (
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead className="bg-light">
                            <tr>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-user mr-2"></i>Nome
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-envelope mr-2"></i>E-mail
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-shield-alt mr-2"></i>Nível de Acesso
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-users mr-2"></i>Turma
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-id-card mr-2"></i>CPF
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-phone mr-2"></i>Telefone
                              </th>
                              <th className="border-0 font-weight-bold text-dark">
                                <i className="fas fa-toggle-on mr-2"></i>Status
                              </th>
                              <th className="border-0 font-weight-bold text-dark text-center">
                                <i className="fas fa-cogs mr-2"></i>Ações
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {usuarios &&
                              usuarios.map((usuario, idx) => (
                                <tr key={usuario.id || idx} className="border-bottom">
                                  <td className="align-middle">
                                    <div className="d-flex align-items-center">
                                      {/* mesma miniatura das listagens de redações */}
                                      <div style={{ marginRight: 10 }}>
                                        <MiniaturaFoto
                                          foto={usuario.foto}
                                          nome={usuario.name}
                                          tamanho={40}
                                        />
                                      </div>
                                      <div style={{ minWidth: 0 }}>
                                        <div className="font-weight-bold text-dark">{usuario.name}</div>
                                        <small className="text-muted">ID: {usuario.id}</small>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="align-middle">
                                    <span className="text-dark">{usuario.email}</span>
                                  </td>
                                  <td className="align-middle">
                                    <span className={`badge badge-${usuario.type === 'a' ? 'primary' : usuario.type === 'm' ? 'success' : usuario.type === 's' ? 'info' : usuario.type === 'c' ? 'warning' : 'secondary'} px-3 py-2`}>
                                      {getType(usuario.type)}
                                    </span>
                                  </td>
                                  <td className="align-middle">
                                    <span className="text-dark">{usuario.turma || 'Não definida'}</span>
                                  </td>
                                  <td className="align-middle">
                                    <span className="text-dark">{usuario.cpf || 'Não informado'}</span>
                                  </td>
                                  <td className="align-middle">
                                    <span className="text-dark">{usuario.phone || 'Não informado'}</span>
                                  </td>
                                  <td className="align-middle">
                                    <span className={`badge badge-${usuario.ativado === 1 ? 'success' : 'danger'} px-3 py-2`}>
                                      <i className={`fas fa-${usuario.ativado === 1 ? 'check-circle' : 'times-circle'} mr-1`}></i>
                                      {usuario.ativado === 1 ? "Ativo" : "Inativo"}
                                    </span>
                                  </td>
                                  <td className="align-middle text-center">
                                    <div className="d-flex gap-1 justify-content-center">
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-redacoes">
                                            Ver redações do aluno
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          variant="outline-success"
                                          data-id={usuario.id}
                                          onClick={getRedacoes}
                                          size="sm"
                                          className="d-flex align-items-center"
                                        >
                                          <i className="fas fa-file-alt"></i>
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-pacotes">
                                            Ver pacotes do usuário
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          variant="outline-info"
                                          data-id={usuario.id}
                                          onClick={getPacote}
                                          size="sm"
                                          className="d-flex align-items-center"
                                        >
                                          <i className="fas fa-box"></i>
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-editar">
                                            Editar usuário
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          variant="outline-warning"
                                          data-id={usuario.id}
                                          onClick={editUser}
                                          size="sm"
                                          className="d-flex align-items-center"
                                        >
                                          <i className="fas fa-edit"></i>
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-deletar">
                                            Deletar usuário
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          variant="outline-danger"
                                          data-id={usuario.id}
                                          data-nome={usuario.name}
                                          onClick={deleteUser}
                                          size="sm"
                                          className="d-flex align-items-center"
                                        >
                                          <i className="fas fa-trash"></i>
                                        </Button>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Paginação */}
                    {totalPages > 1 && (
                      <div className="border-top p-4">
                        {/*
                          flex-wrap + rolagem no nav: com muitas páginas a lista de
                          botões passava da largura da tela no celular, esticando o
                          documento inteiro e quebrando o layout da página.
                        */}
                        <div
                          className="d-flex flex-wrap justify-content-between align-items-center"
                          style={{ gap: '12px' }}
                        >
                          <div className="text-muted">
                            <i className="fas fa-info-circle mr-2"></i>
                            Mostrando {usuarios.length} de {totalUsers} usuários
                          </div>
                          <nav
                            aria-label="Navegação de páginas"
                            style={{ maxWidth: '100%', overflowX: 'auto' }}
                          >
                            <ul className="pagination pagination-sm mb-0 flex-nowrap">
                              {/* Botão Anterior */}
                              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button
                                  className="page-link d-flex align-items-center"
                                  onClick={() => setCurrentPage(currentPage - 1)}
                                  disabled={currentPage === 1}
                                >
                                  <i className="fas fa-chevron-left mr-1"></i>
                                  Anterior
                                </button>
                              </li>

                              {/* Números das páginas */}
                              {(() => {
                                const pages: JSX.Element[] = [];
                                const maxVisiblePages = 5;
                                let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                                let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

                                // Ajustar startPage se estivermos no final
                                if (endPage - startPage + 1 < maxVisiblePages) {
                                  startPage = Math.max(1, endPage - maxVisiblePages + 1);
                                }

                                // Primeira página se não estiver visível
                                if (startPage > 1) {
                                  pages.push(
                                    <li key="1" className="page-item">
                                      <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(1)}
                                      >
                                        1
                                      </button>
                                    </li>
                                  );
                                  if (startPage > 2) {
                                    pages.push(
                                      <li key="ellipsis1" className="page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }
                                }

                                // Páginas visíveis
                                for (let i = startPage; i <= endPage; i++) {
                                  pages.push(
                                    <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(i)}
                                      >
                                        {i}
                                      </button>
                                    </li>
                                  );
                                }

                                // Última página se não estiver visível
                                if (endPage < totalPages) {
                                  if (endPage < totalPages - 1) {
                                    pages.push(
                                      <li key="ellipsis2" className="page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }
                                  pages.push(
                                    <li key={totalPages} className="page-item">
                                      <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(totalPages)}
                                      >
                                        {totalPages}
                                      </button>
                                    </li>
                                  );
                                }

                                return pages;
                              })()}

                              {/* Botão Próxima */}
                              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button
                                  className="page-link d-flex align-items-center"
                                  onClick={() => setCurrentPage(currentPage + 1)}
                                  disabled={currentPage === totalPages}
                                >
                                  Próxima
                                  <i className="fas fa-chevron-right ml-1"></i>
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        {/* Modal de Redações */}
        <Modal show={showRedacao} onHide={handleCloseRedacao} size="xl">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title className="d-flex align-items-center">
              <i className="fas fa-file-alt mr-2"></i>
              Redações do Aluno
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {redacoes.length >= 1 ? (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <tbody>
                    {redacoes.map((redacao, idx) => (
                      <React.Fragment key={`redacao-${idx}`}>
                        <tr className="bg-light">
                          <th colSpan={7} className="text-center py-3">
                            <div className="d-flex align-items-center justify-content-center">
                              <i className="fas fa-edit text-primary mr-2"></i>
                              <span className="font-weight-bold text-dark">{redacao.nome}</span>
                            </div>
                          </th>
                        </tr>
                        <tr className="bg-secondary text-white">
                          <th scope="col" className="text-center">C1</th>
                          <th scope="col" className="text-center">C2</th>
                          <th scope="col" className="text-center">C3</th>
                          <th scope="col" className="text-center">C4</th>
                          <th scope="col" className="text-center">C5</th>
                          <th scope="col" className="text-center">
                            <i className="fas fa-calculator mr-1"></i>TOTAL
                          </th>
                        </tr>
                        <tr>
                          <td className="text-center align-middle">
                            <span className={`badge badge-${redacao.competencia1 ? 'success' : 'secondary'} px-3 py-2`}>
                              {redacao.competencia1 || '-'}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            <span className={`badge badge-${redacao.competencia2 ? 'success' : 'secondary'} px-3 py-2`}>
                              {redacao.competencia2 || '-'}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            <span className={`badge badge-${redacao.competencia3 ? 'success' : 'secondary'} px-3 py-2`}>
                              {redacao.competencia3 || '-'}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            <span className={`badge badge-${redacao.competencia4 ? 'success' : 'secondary'} px-3 py-2`}>
                              {redacao.competencia4 || '-'}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            <span className={`badge badge-${redacao.competencia5 ? 'success' : 'secondary'} px-3 py-2`}>
                              {redacao.competencia5 || '-'}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            {redacao.competencia1 &&
                              redacao.competencia2 &&
                              redacao.competencia3 &&
                              redacao.competencia4 &&
                              redacao.competencia5 ? (
                              <span className="badge badge-primary px-3 py-2 font-weight-bold" style={{ fontSize: '14px' }}>
                                {parseInt(redacao.competencia1) +
                                  parseInt(redacao.competencia2) +
                                  parseInt(redacao.competencia3) +
                                  parseInt(redacao.competencia4) +
                                  parseInt(redacao.competencia5)}
                              </span>
                            ) : (
                              <span className="badge badge-secondary px-3 py-2">-</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={6} className="border-0 py-2"></td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5">
                <i className="fas fa-file-alt text-muted" style={{ fontSize: '3rem' }}></i>
                <h5 className="mt-3 text-muted">Nenhuma redação encontrada</h5>
                <p className="text-muted">Este aluno ainda não possui redações cadastradas.</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="outline-secondary" onClick={handleCloseRedacao} className="d-flex align-items-center">
              <i className="fas fa-times mr-2"></i>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showPacote} onHide={handleClosePacote} size="lg">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title className="d-flex align-items-center">
              <i className="fas fa-box mr-2"></i>
              Pacotes Contratados
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {pacotes && pacotes.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="text-center border-0">
                        <i className="fas fa-tag text-success mr-1"></i>
                        Pacote Contratado
                      </th>
                      <th scope="col" className="text-center border-0">
                        <i className="fas fa-file-alt text-success mr-1"></i>
                        Quantidade
                      </th>
                      <th scope="col" className="text-center border-0">
                        <i className="fas fa-check-circle text-success mr-1"></i>
                        Disponível
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pacotes.map((pacote, idx) => (
                      <tr key={pacote.id || idx} className="border-bottom">
                        <td className="align-middle text-center">
                          <div className="d-flex align-items-center justify-content-center">
                            <span className="font-weight-bold">{pacote.nome}</span>
                          </div>
                        </td>
                        <td className="align-middle text-center">
                          <span className="badge badge-info px-3 py-2">
                            {pacote.qtd} redações
                          </span>
                        </td>
                        <td className="align-middle text-center">
                          <span className={`badge ${Number(pacote.sobra) > 0 ? 'badge-success' : 'badge-warning'} px-3 py-2 font-weight-bold`}>
                            {pacote.sobra} disponível
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5">
                <i className="fas fa-box text-muted" style={{ fontSize: '3rem' }}></i>
                <h5 className="mt-3 text-muted">Nenhum pacote encontrado</h5>
                <p className="text-muted">Este aluno ainda não possui pacotes contratados.</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="outline-secondary" onClick={handleClosePacote} className="d-flex align-items-center">
              <i className="fas fa-times mr-2"></i>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDelete} onHide={handleCloseDelete} centered>
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title className="d-flex align-items-center">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              Confirmar Exclusão
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-4">
            <div className="mb-4">
              <i className="fas fa-user-times text-danger" style={{ fontSize: '4rem' }}></i>
            </div>
            <h5 className="mb-3">Atenção!</h5>
            <p className="mb-3">
              Deseja realmente deletar o usuário <strong className="text-danger">{name}</strong>?
            </p>
            <div className="alert alert-warning d-flex align-items-center" role="alert">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              <small>Esta ação não pode ser desfeita!</small>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-light justify-content-center">
            <Button variant="outline-secondary" onClick={handleCloseDelete} className="d-flex align-items-center mr-2">
              <i className="fas fa-times mr-2"></i>
              Cancelar
            </Button>
            <Button variant="danger" onClick={handleDeleteUser} className="d-flex align-items-center">
              <i className="fas fa-trash mr-2"></i>
              Sim, Deletar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showEdit} onHide={handleCloseEdit} size="lg">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title className="d-flex align-items-center">
              <i className="fas fa-user-edit mr-2"></i>
              Editar Usuário
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <Form>
              {/* foto no topo: é o campo que o usuário identifica de relance */}
              <Form.Group className="mb-4">
                <Form.Label className="d-flex align-items-center">
                  <i className="fas fa-camera text-primary mr-2"></i>
                  Foto do Usuário
                </Form.Label>
                <FotoUsuario
                  fotoAtual={fotoAtual}
                  arquivo={fotoArquivo}
                  onEscolher={setFotoArquivo}
                  onRemover={() => removerFotoAtual(userID)}
                  nome={name}
                />
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-user text-primary mr-2"></i>
                      Nome do Usuário
                    </Form.Label>
                    <Form.Control
                      placeholder="Digite o nome do usuário"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-envelope text-primary mr-2"></i>
                      E-mail do Usuário
                    </Form.Label>
                    <Form.Control
                      placeholder="Digite o e-mail do usuário"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-phone text-primary mr-2"></i>
                      Telefone do Usuário
                    </Form.Label>
                    <Form.Control
                      placeholder="Digite o telefone do usuário"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-shield-alt text-primary mr-2"></i>
                      Nível de Acesso
                    </Form.Label>
                    <Form.Control
                      onChange={(e) => setType(e.target.value)}
                      as="select"
                      defaultValue={type}
                      className="form-control-lg"
                    >
                      <option value="">Selecione o nível de acesso</option>
                      <option value="a">Admin</option>
                      <option value="m">Monitor</option>
                      <option value="e">Estudante</option>
                      <option value="s">Suporte</option>
                      <option value="c">Corretor</option>
                    </Form.Control>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-toggle-on text-primary mr-2"></i>
                      Status do Usuário
                    </Form.Label>
                    <Form.Control
                      onChange={(e) => setAtivado(parseInt(e.target.value))}
                      as="select"
                      defaultValue={ativado}
                      className="form-control-lg"
                    >
                      <option value="">Selecione o status</option>
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </Form.Control>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-users text-primary mr-2"></i>
                      Turma
                    </Form.Label>
                    <Form.Control
                      onChange={(e) => setTurmaID(e.target.value)}
                      as="select"
                      defaultValue={turmaID}
                      className="form-control-lg"
                    >
                      <option value="">Selecione uma turma</option>
                      {turmas &&
                        turmas.map((turma, idx) => (
                          <option key={turma.id || idx} value={turma.id}>{turma.name}</option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-lock text-primary mr-2"></i>
                      Nova Senha
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Digite a nova senha"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label className="d-flex align-items-center">
                      <i className="fas fa-lock text-primary mr-2"></i>
                      Confirmar Senha
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirme a nova senha"
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                      className="form-control-lg"
                    />
                  </Form.Group>
                </div>
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-light">
            <Button variant="outline-secondary" onClick={handleCloseEdit} className="d-flex align-items-center mr-2">
              <i className="fas fa-times mr-2"></i>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleEditUser} className="d-flex align-items-center">
              <i className="fas fa-save mr-2"></i>
              Salvar Alterações
            </Button>
          </Modal.Footer>
        </Modal>
      </S.MainWrapper>
    </Template>
  );
}

export default Usuarios;
